import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';

const useMessageUsersAutoWelcomeMessageOnlineUsersStats = (enabled: boolean) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const axios = useAxios();

    const fetchData = async (): Promise<{
        totalMessagesSent: number;
    }> => {
        if (userContext.jwtToken && settingsContext.apiKey && 'userId' in params && params.userId) {
            const query: string = `${settingsContext.routes.messageUsers.base}${params.userId}/autoWelcomeMessagesOnlineUsers/totalMessagesSent`;

            return axios
                .get(query)
                .then(async response => {
                    if (response.status === 200) {
                        return response.data;
                    }

                    return {
                        totalMessagesSent: 0,
                    };
                })
                .catch(error => {
                    console.error(error);

                    return {
                        totalMessagesSent: 0,
                    };
                });
        }

        return {
            totalMessagesSent: 0,
        };
    };

    return useQuery(['messageUsersAutoWelcomeMessageOnlineUsersStats', params.userId], () => fetchData(), {
        refetchOnWindowFocus: false,
        // Stale time 30 seconds
        staleTime: 30000,
        refetchInterval: 30000,
        enabled: userContext.jwtToken && settingsContext.apiKey && params.userId && enabled ? true : false,
    });
};

export default useMessageUsersAutoWelcomeMessageOnlineUsersStats;
